import {
  AfterContentInit,
  Component,
  ContentChild, ElementRef,
  forwardRef,
  Host,
  Input,
  OnInit,
  Optional,
  SkipSelf, ViewChild
} from '@angular/core';
import {FormGroupContext} from "./form-group-context.interface";
import {FORM_GROUP_CONTEXT} from "./form-group-context.tokens";
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgControl
} from "@angular/forms";
import {FormGroupExtension} from "./extensions/form-group-extension/form-group.extension";

@Component({
  selector: 'form-group-context',
  templateUrl: './form-group-context.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormGroupContextComponent),
      multi: true,
    },
  ]
})
export class FormGroupContextComponent implements OnInit, AfterContentInit, ControlValueAccessor {

  @Input() label: string;

  @ContentChild(FORM_GROUP_CONTEXT as any) strategy: FormGroupContext;
  @ViewChild('contentEl') set contentEl$(value: ElementRef) {
    if (value) {
      this.isEmpty = !value.nativeElement.children.length;
    } else {
      this.isEmpty = false;
    }
  }

  localeValue: any;
  isEmpty: boolean = false;

  private onTouched = () => {};

  private onChange: (value: any) => void = () => {};

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit (): void {
    if (!(this.strategy instanceof FormGroupExtension)) return;

    this.strategy.setValue(this.localeValue);

    this.strategy.valueChanges.subscribe(value => {
      this.localeValue = value;
      this.onChange(this.localeValue);
    });
  }

  registerOnChange(onChange: (value: any) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.strategy.setDisabled(disabled);
  }

  writeValue(value: any) {
    this.localeValue = value;

    if (this.strategy)
      this.strategy.setValue(this.localeValue);
  }

}
